export {
  MoreOptionsComponent,
  MoreOptionsIconColor,
  MoreOptionsIconType,
  MoreOptionsSize,
} from './more-options.component';
